var _circle, _circle2, _path, _path2, _circle3, _text;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgIllustrationInfo = function SvgIllustrationInfo(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 180 180",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 122.7,
    cy: 127,
    r: 27.8,
    fill: "var(--secondary-fill)",
    transform: "rotate(-90 122.7 127)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 53.8,
    r: 27.8,
    fill: "var(--secondary-fill)",
    transform: "rotate(-90 57 53.8)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--secondary-fill)",
    d: "m134 62 2.2-18.7 18.7 2.3-2.2 18.6zM25 138.7l4.1-18.3 18.4 4-4.2 18.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M91.5 48.3a43.8 43.8 0 0 0-44.2 43.4A43.8 43.8 0 0 0 91.5 135a43.8 43.8 0 0 0 44.2-43.3c0-24-19.8-43.4-44.2-43.4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.5,
    cy: 91.5,
    r: 15,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 91.5,
    y: 97,
    fill: "#fff",
    fontFamily: "Arial, sans-serif",
    fontSize: 18,
    fontWeight: "bold",
    textAnchor: "middle"
  }, "i")));
};
export default SvgIllustrationInfo;